export default __webpack_public_path__ + "static/media/tela-rosa-azul.bc9a07f9.png";